import axiosInstance from "../api/axiosInstance";
// GET list with pagination and search
export const fetchReview = (params) => axiosInstance.get("/admin/reviewList", { params });
// Get By ID
export const reviewDetail = (id) => axiosInstance.get(`/admin/reviewDetail/${id}`);
